import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "service-amount"
  }, [_c('div', {
    staticClass: "amount"
  }, [_c('div', {
    staticClass: "amount-top"
  }, [_c('div', {
    staticClass: "amount-top-text font-size-h3-large"
  }, [_c('div', {}, [_vm._v(i18n.tc("540"))])]), _c('div', {
    staticClass: "amount-top-link font-size-h3-normal"
  }, [_c('div', {
    staticClass: "amount-top-link-text"
  }, [_vm._v(i18n.tc("603") + _vm._s(_vm.service.total_amount || 0) + i18n.tc("604"))])])]), _c('ServiceAmountTable', {
    attrs: {
      "service": _vm.service,
      "sparePartList": _vm.sparePartList,
      "moneyItemList": _vm.moneyItemList,
      "extServiceItems": _vm.extServiceItems
    }
  })], 1), _c('div', {
    staticClass: "receive font-size-h3-normal"
  }, [_c('div', {
    staticClass: "receive-title font-size-h3-large"
  }, [_vm._v(i18n.tc("607"))]), _c('div', {
    staticClass: "receive-item"
  }, [_c('div', {
    staticClass: "receive-item-label"
  }, [_vm._v(i18n.tc("608"))]), _c('div', {
    staticClass: "receive-item-value"
  }, [_vm._v(_vm._s(_vm.service.pay_createtime))])]), _c('div', {
    staticClass: "receive-item"
  }, [_c('div', {
    staticClass: "receive-item-label"
  }, [_vm._v(i18n.tc("609"))]), _c('div', {
    staticClass: "receive-item-value"
  }, [_vm._v(" " + _vm._s(_vm.payTypeMapping[Number(_vm.service.pay_type)] || '') + " ")])]), _c('div', {
    staticClass: "receive-item"
  }, [_c('div', {
    staticClass: "receive-item-label"
  }, [_vm._v(i18n.tc("610"))]), _c('div', {
    staticClass: "receive-item-value"
  }, _vm._l(_vm.pics, function (item, index) {
    return _c('img', {
      key: index,
      staticClass: "receive-item-value-img",
      attrs: {
        "src": item.img_url
      },
      on: {
        "click": function ($event) {
          return _vm.show(index);
        }
      }
    });
  }), 0)])]), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('Previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.picsForPreviewer,
      "options": _vm.options
    }
  })], 1)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };